export const union = <T>(setA: Set<T>, setB: Set<T>): Set<T> => {
  return new Set([...setA, ...setB]);
};

export const intersection = <T>(setA: Set<T>, setB: Set<T>): Set<T> => {
  return new Set([...setA].filter((x) => setB.has(x)));
};

export const difference = <T>(setA: Set<T>, setB: Set<T>): Set<T> => {
  return new Set([...setA].filter((x) => !setB.has(x)));
};

export const isSubset = <T>(setA: Set<T>, setB: Set<T>): boolean => {
  return [...setA].every((x) => setB.has(x));
};

export const isSuperset = <T>(setA: Set<T>, setB: Set<T>): boolean => {
  return isSubset(setB, setA);
};
